import React from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import cx from 'classnames';
import { connect } from 'react-redux';
import { pluck } from 'underscore';

// ducks
import { CONTACT_SUBMIT } from '../../ducks/Home';

// components
import EmailListingsForm from '../../forms/email-listings-form/email-listings-form';

// modules
import BS from '../../theme/Bootstrap';

let FavoriteSearchEmailModal = props => {
  const {
    className,
    isOpen,
    onToggle,
    propertyClass,
    mlsIds = [],
    CONTACT_SUBMIT,
    ...modalProps
  } = props;

  return (
    <Modal
      className={cx(className, BS.modalDialogCentered)}
      isOpen={isOpen}
      toggle={onToggle}
      {...modalProps}
    >
      <ModalHeader
        toggle={() => {
          onToggle(false);
        }}
      >
        Email Listings
      </ModalHeader>
      <ModalBody>
        <EmailListingsForm
          onCancelClick={() => onToggle(false)}
          enableReinitialize={true}
          initialValues={{
            message:
              props.message ||
              'Take a look at the properties I found on <a href="https://www.naplesarea.com">Naplesarea.com</a>.',
            id: mlsIds.join(','),
            type: 'property'
          }}
          onSubmit={(values, dispatch, props) => {
            return CONTACT_SUBMIT(values).then(function () {
              setTimeout(() => onToggle(false), 1000);
            });
          }}
        />
      </ModalBody>
    </Modal>
  );
};

export default connect(
  (state, props) => {
    if (props.mlsIds) {
      return {
        mlsIds: props.mlsIds
      };
    } else {
      const { propertyClass = 'residential' } = props;
      const favorites = state.FavoriteSearch.get('favorites').filter(favorite => {
        return favorite.propertyClass === propertyClass;
      });

      return {
        mlsIds: pluck(favorites, 'mlsNumber')
      };
    }
  },
  {
    CONTACT_SUBMIT
  }
)(FavoriteSearchEmailModal);



// WEBPACK FOOTER //
// ./src/containers/FavoriteSearch/FavoriteSearchEmailModal.js